<template>
  <div class="html">
    <div class="center">
      <el-menu
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#346294"
        text-color="#fff"
        active-text-color="#00C846"
      >
        <div class="logo">
          <img src="@/assets/logo.png" alt="logo" />
          <span>成都科必特科技有限公司</span>
        </div>
        <div class="menu">
          <el-menu-item index="1" @click="$router.push('/')">
            <!-- <router-link :to="{ name: 'Home' }">  -->
            首页
            <!-- </router-link> -->
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">小科平台</template>
            <el-menu-item index="2-1" @click="$router.push('/ZQPlatform')"
              >政企引擎</el-menu-item
            >
            <el-menu-item index="2-2" @click="$router.push('/ZWPlatform')"
              >政务OA办公</el-menu-item
            >
            <el-menu-item index="2-3" @click="$router.push('/YCPlatform')"
              >业财一体化</el-menu-item
            >
            <el-menu-item index="2-4" @click="$router.push('/FKPlatform')"
              >费控管理</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">智能硬件</template>
            <el-menu-item index="3-1" @click="$router.push('/Machine')"
              >会议机</el-menu-item
            >
            <el-menu-item index="3-2" @click="$router.push('/HighShotMeter')"
              >高拍仪</el-menu-item
            >
            <el-menu-item index="3-3" @click="$router.push('/VoiceRecorder')"
              >录音笔</el-menu-item
            >
            <el-menu-item
              index="3-4"
              @click="$router.push('/TranslationMachine')"
              >翻译笔</el-menu-item
            >
            <el-menu-item index="3-5" @click="$router.push('/LearningMachine')"
              >学习机</el-menu-item
            >
            <el-menu-item index="3-6" @click="$router.push('/WillStaff')"
              >会参谋</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="4" @click="goFinancial">小科邦</el-menu-item>
          <el-menu-item index="5" @click="$router.push('/SoftwareSolutions')"
            >软件解决方案</el-menu-item
          >
          <el-menu-item index="6" @click="$router.push('/ContactUs')">
            联系我们
          </el-menu-item>
        </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    goFinancial() {
      window.open('http://www.cdkbit.com/')
    }
  }
}
</script>

<style lang="less" scoped>
.html {
  width: 100%;
  background-color: #346294;
  .center {
    width: 1200px;
    margin: 0 auto;
    .el-menu-demo {
      display: flex;
      width: 100%;
      .logo {
        display: flex;
        align-items: center;
        width: 30%;
        img {
          height: 40px;
          width: 40px;
          margin: 0 15px;
        }
        span {
          color: #fff;
        }
      }
      .menu {
        width: 70%;
        display: flex;
        margin-left: 160px;
        justify-content: space-around;
      }
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 1px solid #346294;
    }
  }
}
</style>
